import { render, staticRenderFns } from "./video.vue?vue&type=template&id=f431a8b6&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"
import style0 from "./video.vue?vue&type=style&index=0&id=f431a8b6&prod&lang=scss&scoped=true"
import style1 from "./video.vue?vue&type=style&index=1&id=f431a8b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f431a8b6",
  null
  
)

export default component.exports